// convert a hexadecimal color string to 0..255 R,G,B
export function hexToRgb(hex, isFormatted) {
  if (hex === null || typeof hex === 'undefined') {
    return null;
  }
  const formatted = isFormatted || false;
  hex = hex.replace('#', '').replace('0x', '');
  hex =
    hex.length < 6
      ? hex
          .split('')
          .map(c => `${c}${c}`)
          .join('')
      : hex;
  hex = parseInt('0x' + hex, 16);
  const r = hex >> 16;
  const g = (hex >> 8) & 0xff;
  const b = hex & 0xff;
  return formatted ? `rgb(${r},${g},${b})` : [r, g, b];
}

// convert 0..255 R,G,B values to a hexadecimal color string
export function rgbToHex(r, g, b) {
  const bin = (r << 16) | (g << 8) | b;
  return (h => {
    return new Array(7 - h.length).join('0') + h;
  })(bin.toString(16).toLowerCase());
}
